import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about/:tid',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/about/About.vue')
    },
    {
      path: '/products/:tid',
      name: 'products',
      component: () => import('./views/products/Products.vue')
    },
    {
      path: '/product/:tid/:id',
      name: 'product',
      component: () => import('./views/product/Product.vue')
    },
    {
      path: '/news/:tid',
      name: 'news',
      component: () => import('./views/news/News.vue')
    },
    {
      path: '/newsdetail/:tid/:id',
      name: 'newsdetail',
      component: () => import('./views/newsdetail/Newsdetail.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/contact/Contact.vue')
    },
    {
      path: '/job',
      name: 'job',
      component: () => import('./views/job/Job.vue')
    },
    {
      path: '/Research/:tid',
      name: 'research',
      component: () => import('./views/research/keyan.vue')
    },
    {
      path: '/singlepage/:id',
      name: 'singlepage',
      component: () => import('./views/singlepage/singlepage.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }else if(to.name=='about'){
      return
    } else {
      return { x: 0, y: 0 }
    }
  }
})
